export default __webpack_public_path__ + "static/media/Icons-45.45f43a07.png";